/**
 * Minimal type for auth.currentUser (compatible with Firebase User).
 * Replace this file with: import { getAuth } from 'firebase/auth'; export const auth = getAuth(app);
 */
export type AuthUserLike = {
  getIdToken(): Promise<string>;
  getIdTokenResult(): Promise<{ claims?: Record<string, unknown> }>;
};

export const auth: { currentUser: AuthUserLike | null } = {
  currentUser: null,
};
